// @alignova/shared — the single source of truth imported by both client and server.
// Permission catalog, DTO types, and validation schemas will accrete here so a
// server route guard and a client `can()` check can never disagree.

export * from './permissions.js';
export * from './rbac.js';
export * from './format.js';
export * from './phone.js';
export * from './aligner-pricing.js';
export * from './turnaround.js';
export * from './dto/auth.js';
export * from './dto/rbac.js';
export * from './dto/audit.js';
export * from './dto/cases.js';
export * from './dto/case-collab.js';
export * from './dto/clinics.js';
export * from './dto/chat.js';
export * from './dto/patient-app.js';
export * from './dto/compliance.js';
export * from './dto/setup.js';
export * from './dto/accounting.js';
export * from './dto/push.js';
export * from './dto/patients.js';
export * from './dto/grading.js';
export * from './dto/finance.js';
export * from './dto/manufacturing.js';
export * from './dto/settings.js';
export * from './dto/users.js';
export * from './dto/analytics.js';
export * from './dto/notifications.js';
export * from './dto/workflow.js';
export * from './dto/portal.js';
export * from './dto/wf-billing.js';
export * from './dto/field.js';
export * from './dto/field-ops.js';
export * from './pricing.js';

export const API_PREFIX = '/api' as const;

/** Health/readiness payload returned by GET /api/health. */
export interface HealthResponse {
  ok: boolean;
  service: string;
  /** Which datastore backend is active: embedded SQLite or Postgres. */
  datastore: 'sqlite' | 'postgres' | 'unknown';
  /** Server time as an ISO-8601 string (UTC). Formatting to DD/MM/YYYY happens client-side. */
  time: string;
}

/** Uniform error envelope for API responses. */
export interface ApiError {
  error: string;
  code?: string;
}
